import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetFacilityDetail } from "../../../utilities/api/Facilities";
import { FacilityDetailType } from "../../../utilities/types";
import { messages } from "../../../utilities/Messages";

type ErrorMessageType = {
  message: string;
}

const initialState = {
  SingleFacilityData: {} as FacilityDetailType,
  isLoading: true as boolean,
  errorMessage: {} as ErrorMessageType,
};

export const SingleFacility = createAsyncThunk(
  "SingleFacility/SingleFacilityData",
  (id: string) => GetFacilityDetail(id)
);

const SingleFacilityDataSlice = createSlice({
  name: "SingleFacility",
  initialState,
  reducers: {
    resetSingleFacilitySlice: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(SingleFacility.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(
        SingleFacility.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          if (action.payload.statusCode === 200) {
            state.SingleFacilityData = {
              name: action.payload.data.name,
              isActive: action.payload.data.isActive,
              addressLine1: action.payload.data.address?.addressLine1,
              addressLine2: action.payload.data.address?.addressLine2,
              city: action.payload.data.address?.city,
              state: action.payload.data.address?.state,
              country: action.payload.data.address?.country,
              pincode: action.payload.data.address?.pincode,
              landmark: action.payload.data.address?.landmark,
              latitude: action.payload.data.address?.latitude,
              longitude: action.payload.data.address?.longitude,
              id: action.payload.data.id,
            };
          }
        }
      )
      .addCase(SingleFacility.rejected, (state, action) => {
        state.errorMessage = { message: messages.error.internal_server_error };
      });

  },
});

export default SingleFacilityDataSlice.reducer;
export const { resetSingleFacilitySlice } = SingleFacilityDataSlice.actions;
